import { render, staticRenderFns } from "./Psychology.vue?vue&type=template&id=5ed6ab14&scoped=true&"
var script = {}
import style0 from "./Psychology.vue?vue&type=style&index=0&id=5ed6ab14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6ab14",
  null
  
)

export default component.exports